let html = `<div class="card-episode selector layer--visible layer--render">
    <div class="card-episode__body">
        <div class="full-episode">
            <div class="full-episode__img">
                <img />
            </div>

            <div class="full-episode__body">
                <div class="full-episode__num">{num}</div>
                <div class="full-episode__name">{name}</div>
                <div class="full-episode__date">{date}</div>
            </div>
        </div>
    </div>
    <div class="card-episode__footer">
        <div class="card__imgbox">
            <div class="card__view">
                <img class="card__img" />
            </div>
        </div>

        <div class="card__left">
            <div class="card__title">{title}</div>
            <div class="card__age">{release_year}</div>
        </div>
    </div>
</div>`

export default html